<template>
  <v-container :fluid="true" class="page_container">
    <div class="event__title">
      <span class="event__title--text" v-if="!search_panel && $vuetify.display.width < 769 || $vuetify.display.width >= 769">
        События
      </span>
      <v-row no-gutters align="start" justify="end">

        <div v-if="region_panel && !filter_panel && !search_panel" class="search__field">
          <v-autocomplete
            class="search__field_input"
            ref="region-field-input"
            color="#3254B9"
            base-color="#313743"
            variant="outlined"
            item-title="text"
            item-value="value"
            label="Выберите регион партнера"
            no-data-text="Нет подходящих данных"
            :items="regions"
            v-model="filters.region"
            :loading="isLoading"
            :disabled="isLoading"
            @update:model-value="clickRegion"
          >
            <template v-slot:label>
              <div class="label__text">
                Регион
              </div>
            </template>
            <template v-slot:prepend-item>
              <v-list-item @click="filterEventsToRegion(true)">
                <v-list-item-title>Мой регион</v-list-item-title>
              </v-list-item>
            </template>
            <template v-slot:append>
              <div class="search__field_label" @click="closeRegion" style="cursor: pointer">
                <v-icon :size="$vuetify.display.width >= 769 ? 45 : 30" color="#3254B9" class="mr-n2">close</v-icon>
              </div>
            </template>
          </v-autocomplete>
        </div>
        <v-icon :size="$vuetify.display.width >= 769 ? 32 : 20" color="#3254B9" class="search_icon mr-1" @click="openRegion" v-else-if="!region_panel && !filter_panel && !search_panel">public</v-icon>
        <div v-if="filter_panel && !search_panel && !region_panel" class="search__field">
          <v-autocomplete
            class="search__field_input"
            ref="filter-field-input"
            color="#3254B9"
            base-color="#313743"
            variant="outlined"
            item-title="text"
            item-value="value"
            label="Выберите тэг партнера"
            no-data-text="Нет подходящих данных"
            :items="eventTags"
            v-model="filters.tag"
            :loading="isLoading"
            :disabled="isLoading"
            @update:model-value="clickFilter"
          >
            <template v-slot:label>
              <div class="label__text">
                Категории
              </div>
            </template>
            <template v-slot:append>
              <div class="search__field_label" @click="closeFilter" style="cursor: pointer">
                <v-icon :size="$vuetify.display.width >= 769 ? 45 : 30" color="#3254B9" class="mr-n2">close</v-icon>
              </div>
            </template>
          </v-autocomplete>
        </div>
        <v-icon :size="$vuetify.display.width >= 769 ? 30 : 20" color="#3254B9" class="search_icon mr-2" @click="openFilter" v-else-if="!region_panel && !filter_panel && !search_panel">$custom_filter</v-icon>
        <div v-if="search_panel && !filter_panel && !region_panel" class="search__field">
          <v-text-field
            v-model="search.value"
            @keydown.enter="clickSearch"
            ref="search-field-input"
            class="search__field_input"
            color="#3254B9"
            base-color="#313743"
            variant="outlined"
            placeholder="Введите текст и нажмите кнопку поиска"
          >
            <template v-slot:label>
              <div class="search__field_label">
                Поиск
              </div>
            </template>
            <template v-slot:append>
              <div class="search__field_label" @click="closeSearch" style="cursor: pointer">
                <v-icon :size="$vuetify.display.width >= 769 ? 45 : 30" color="#3254B9" class="mr-n2">close</v-icon>
              </div>
            </template>
            <template v-slot:append-inner>
              <v-icon size="20" class="search_icon" @click="clickSearch" v-if="$vuetify.display.mdAndDown">$custom_search</v-icon>
            </template>
          </v-text-field>
        </div>
        <v-icon v-else-if="!filter_panel && !search_panel && !region_panel" :size="$vuetify.display.width >= 769 ? 30 : 20" class="search_icon" @click="openSearch">$custom_search</v-icon>
      </v-row>
    </div>
    <v-row no-gutters class="mb-5" justify="end" v-if="$vuetify.display.width > 1596">
      <div v-for="(item, key) in filters_names" :key="key" class="ma-2">
        <v-btn color="#376FFE" variant="flat" class="filter-btn" @click="toggleBoolFilter(key)">
          {{item}}
          <v-icon v-if="pagination.filters[key] !== null && !!pagination.filters[key]">cancel</v-icon>
        </v-btn>
      </div>
    </v-row>
    <div
        class="event__content"
    >
      {{eventTags}}
      <div v-if="events.length > 0 && !isLoadingEvents">
        <EventCard
          class="event__content__item"
          v-for="(item, index) in events"
          :key="`event_${index}`"
          :item="item"
          justify_row="space-around"
          style=""
          @singup="reloadData"
        />
        <div class="partner__next" v-if="events.length > 0 && !isLoading && getEventsNext !== null && !isSubLoading" style="margin-top: 50px">
          <v-btn color="#376FFE" height="55" width="212" class="partner__next_btn" :disabled="isLoading || isSubLoading" @click="loadNextItems()">
            ПОКАЗАТЬ ЕЩЁ
          </v-btn>
        </div>
      </div>

      <div v-else-if="events.length === 0 && !isLoadingEvents">
        <NoData/>
      </div>
      <div v-else>
        <v-row no-gutters justify="center" align="center" style="height: 25vh; min-height: 200px">
          <fulfilling-square-spinner
              :animation-duration="4000"
              :size="100"
              color="#34347C"
          />
        </v-row>
      </div>
      <div v-if="isLoadingEvents">
        <v-row no-gutters justify="center" align="center" style="height: 25vh; min-height: 200px">
          <fulfilling-square-spinner
              :animation-duration="4000"
              :size="100"
              color="#34347C"
          />
        </v-row>
      </div>
    </div>
  </v-container>
</template>

<script>
import { defineComponent } from 'vue'
import EventCard from "@/modules/personal_account/calendar/components/EventCard.vue"
import PaginatedDataMapperMixin from "@/mixins/PaginatedDataMapperMixin"
import names from "@/modules/core/routers/names"
import pa_names from "@/modules/personal_account/routers/names"
import { mapActions, mapGetters } from "vuex"
import { FulfillingSquareSpinner } from "epic-spinners"
import NoData from "@/modules/templates/NoData.vue"

export default defineComponent({
  name: "Events",
  components: {
    NoData,
    EventCard,
    FulfillingSquareSpinner
  },
  mixins: [PaginatedDataMapperMixin],
  data () {
    return {
      isLoading: true,
      covers: {},
      search_panel: false,
      search: {
        parameter: 'search',
      },
      search_local_value: undefined,
      isNewEventsLoading: true,
      isSubLoading: false,
      newEvents: [],
      filter_panel: false,
      region_panel: false,
      filters: {
        tag: null,
        region: null,
        home_region: null,
        is_registration_available: null,
        is_archived: false,
        is_iam_participant: null,
        is_iam_waiting: null,
      },
      filters_names: {
        is_registration_available: 'Доступна запись',
        is_archived: 'Архивные',
        is_iam_participant: 'Я записан',
        is_iam_waiting: 'Я в ожидании',
      },
      selectors: {
        eventsTags: [],
        eventsRegions: [],
      },
      new_events_more: false,
      is_append: false
    }
  },
  computed: {
    names: () => names,
    ...mapGetters({
      isAuthenticated: 'auth/isAuthenticated',
      events: 'personal_account/events/getEvents',
      count: 'personal_account/events/getEventsCount',
      isLoadingEvents: 'personal_account/events/isLoadingEvents',
      getEventsNext: 'personal_account/events/getEventsNext',
      regions: 'selectors/regions',
      eventTags: "selectors/eventsTags"
    }),
  },
  methods: {
    ...mapActions({
      load: 'personal_account/events/loadEvents',
      loadEvents: 'personal_account/events/loadEvents',
      loadEventsTags: "selectors/loadEventsTags",
      loadRegions: "selectors/loadRegions"
    }),
    toggleBoolFilter (key) {
      if (key === 'is_archived') {
        this.pagination.filters[key] = !this.pagination.filters[key]
        return
      }
      if (this.pagination.filters[key] !== null && this.pagination.filters[key] !== undefined) {
        this.pagination.filters[key] = null
      } else {
        this.pagination.filters[key] = true
      }
    },
    addCover (items) {
      this.isLoading = false
      this.isSubLoading = false
    },
    loadData (url = undefined, appendParam = undefined, appendValue = undefined) {
      this.loadEvents({
        url: url,
        urlAppend: (url) => {
          if (appendParam) {
            return this.addGetParameter(this.addPageParameter(this.addSizeParameter(url)), appendParam, appendValue)
          } else {
            return this.addGetParameter(this.addPageParameter(this.addSizeParameter(url)), 'is_archived', this.filters.is_archived)
          }
        },
        finalizer: (data, url) => {
          this.setCurrentLoadUrl(url)
          this.isLoading = false
          this.isSubLoading = false
          if (this.is_append) this.is_append = false
        },
        catcher: () => {},
        is_append: this.is_append
      })
    },
    loadNextItems () {
      if (this.getEventsNext !== null) {
        this.isSubLoading = true
        const url = this.getEventsNext
        const startIndex = url.indexOf("page=") + 5 // Получаем индекс символа после "page="
        this.pagination.need_reload = true
        this.pagination.page = url.slice(startIndex)
        this.is_append = true
      }
    },
    loadSelectors () {
      this.loadEventsTags({})
      this.loadRegions({})
    },
    clickSearch () {
      if (this.search.value !== undefined && this.search_local_value !== this.search.value) {
        this.isLoading = true
        this.pagination.need_reload = true
        this.searchData()
        this.search_local_value = this.search.value
      }
    },
    openSearch () {
      this.search_panel = true
      this.$nextTick(() => {
        this.$refs['search-field-input'].focus()
      })
    },
    closeSearch () {
      this.isLoading = true
      this.search_panel = false
      this.search.value = ''
      this.pagination.need_reload = false
      this.pagination.page = 1
      this.$nextTick(() => {
        this.loadData()
      })
    },
    openFilter () {
      this.filter_panel = true
      this.$nextTick(() => {
        this.$refs['filter-field-input'].focus()
      })
    },
    clickFilter () {
      if (this.filters.tag) {
        this.pagination.filters.tag = this.filters.tag
        this.pagination.need_reload = true
        if (this.filter_panel) {
          this.$nextTick(() => {
            this.$refs['filter-field-input'].blur()
          })
        }
      }
    },
    closeFilter () {
      this.isLoading = true
      this.filter_panel = false
      this.filters.tag = null
      this.loadData()
    },
    filterEventsToCategory (event) {
      if (event) {
        this.pagination.filters.tag = event
        this.pagination.need_reload = true
      } else {
        this.isLoading = true
        this.loadData()
      }
    },
    openRegion () {
      this.region_panel = true
      this.$nextTick(() => {
        this.$refs['region-field-input'].focus()
      })
    },
    clickRegion () {
      if (this.filters.region) {
        this.filters.home_region = null
        this.pagination.filters.home_region = null
        this.pagination.filters.region = this.filters.region
        this.pagination.need_reload = true
        if (this.filter_panel) {
          this.$nextTick(() => {
            this.$refs['region-field-input'].blur()
          })
        }
      }
    },
    closeRegion () {
      this.isLoading = true
      this.region_panel = false
      this.filters.region = null
      this.filters.home_region = null
      this.loadData()
    },
    filterEventsToRegion (event) {
      if (event) {
        this.region_panel = false
        this.filters.region = null
        this.pagination.filters.region = null
        this.pagination.filters.home_region = event
        this.pagination.need_reload = true
      }
    },
  },
  created () {
    if (!this.isAuthenticated) {
      this.$router.push({ name: names.MAIN })
    } else {
      this.loadData()
      this.loadSelectors()
    }
  }
})
</script>

<style scoped lang="scss">
.event__content__item {
  margin: 50px 50px 0;

  &:last-child {
    margin-bottom: 50px;
  }
}

.event__title {
  display: flex;
  justify-content: space-between;
}

.event__title--text {
  padding: 0;
  margin-bottom: 30px;
  text-transform: uppercase;
  font-size: 20px;
  font-weight: 700;
  color: #34347C;
  text-align: left;

  &::before {
    margin-right: 28px;
    content: "";
    display: inline-block;
    width: 14px;
    height: 14px;
    background-color: #376FFE;
  }
}

.search__field {
  margin-top: -10px;
  display: flex;
  justify-content: flex-end;
  flex-wrap: nowrap;
  width: 500px;
}

.search__field_input {
  height: 50px;
}

.search__field_label {
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 23px;
  text-align: center;
}

.search_icon {
  cursor: pointer;
}

.event__content {
  text-align: center;
  border-radius: 5px;
  width: 100%;
  background-color: white;
  padding: 25px 25px;
}

.event__next {
  padding-top: 25px;
  padding-bottom: 25px;
}

.event__next_btn {
  border-radius: 10px;
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 22px;
  text-align: center;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #FFFFFF;
}

@media screen and (max-width: 1280px) {
  .event__content {
    padding: 0;
  }
}

@media screen and (max-width: 768px) {
  .event__title {
    margin-top: 20px;
  }

  .event__title--text {
    margin-bottom: 20px;
    font-size: 14px;
    line-height: 17px;

    &::before {
      margin-right: 20px;
      width: 10px;
      height: 10px;
    }
  }

  .search__field_input {
    height: 70px;
  }

  .search__field_label {
    font-size: 14px;
    line-height: 17px;
  }
}
</style>
